// extracted by mini-css-extract-plugin
export var addButton = "ingredient-field-array-module--add-button--03d35";
export var container = "ingredient-field-array-module--container--49da1";
export var deleteButton = "ingredient-field-array-module--delete-button--716da";
export var ingredientSelect = "ingredient-field-array-module--ingredient-select--4820e";
export var inputGroup = "ingredient-field-array-module--input-group--af82f";